module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "trello-right.e6e102c7.svg";